/**
 * @link https://polaris.shopify.com/foundations/formatting-localized-currency
 * @link https://fastspring.com/blog/how-to-format-30-currencies-from-countries-all-over-the-world/
 */
export enum CurrencyLocale {
  AUD = 'en-AU',
  CAD_English = 'en-CA',
  CAD_French = 'fr-CA',
  DKK = 'da-DK',
  EUR_English = 'en-IE',
  EUR_French = 'fr-FR',
  EUR_German = 'de-DE',
  EUR_Netherlands = 'nl-NL',
  GBP = 'en-GB',
  HKD = 'zh-HK',
  JPY = 'ja-JP',
  NZD = 'en-NZ',
  SGD = 'zh-SG',
  USD = 'en-US',
}

export enum CurrencyCode {
  AUD = 'AUD',
  CAD = 'CAD',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  HKD = 'HKD',
  JPY = 'JPY',
  NZD = 'NZD',
  SGD = 'SGD',
  USD = 'USD',
}

export const currencyLocaleLabels: Record<CurrencyLocale, string> = {
  [CurrencyLocale.AUD]: 'Australian Dollar ($, AUD)',
  [CurrencyLocale.CAD_English]: 'Canadian Dollar ($, CAD) - English',
  [CurrencyLocale.CAD_French]: 'Canadian Dollar ($, CAD) - French',
  [CurrencyLocale.DKK]: 'Danish Krone (Kr, DKK)',
  [CurrencyLocale.EUR_English]: 'Euro (€, EUR) - English',
  [CurrencyLocale.EUR_French]: 'Euro (€, EUR) - French',
  [CurrencyLocale.EUR_German]: 'Euro (€, EUR) - German',
  [CurrencyLocale.EUR_Netherlands]: 'Euro (€, EUR) - Netherlands',
  [CurrencyLocale.GBP]: 'British Pounds (£, GBP)',
  [CurrencyLocale.HKD]: 'Hong Kong Dollar ($, HKD)',
  [CurrencyLocale.JPY]: 'Japanese Yen (¥, JPY) ',
  [CurrencyLocale.NZD]: 'New Zealand Dollar ($, NZD)',
  [CurrencyLocale.SGD]: 'Singapore Dollar ($, SGD)',
  [CurrencyLocale.USD]: 'USD',
};

export const currencyPairingMap: Record<CurrencyLocale, CurrencyCode> = {
  [CurrencyLocale.AUD]: CurrencyCode.AUD,
  [CurrencyLocale.CAD_English]: CurrencyCode.CAD,
  [CurrencyLocale.CAD_French]: CurrencyCode.CAD,
  [CurrencyLocale.DKK]: CurrencyCode.DKK,
  [CurrencyLocale.EUR_English]: CurrencyCode.EUR,
  [CurrencyLocale.EUR_French]: CurrencyCode.EUR,
  [CurrencyLocale.EUR_German]: CurrencyCode.EUR,
  [CurrencyLocale.EUR_Netherlands]: CurrencyCode.EUR,
  [CurrencyLocale.GBP]: CurrencyCode.GBP,
  [CurrencyLocale.HKD]: CurrencyCode.HKD,
  [CurrencyLocale.JPY]: CurrencyCode.JPY,
  [CurrencyLocale.NZD]: CurrencyCode.NZD,
  [CurrencyLocale.SGD]: CurrencyCode.SGD,
  [CurrencyLocale.USD]: CurrencyCode.USD,
};

export enum CurrencyFormat {
  Long = 'Long', // $1,250.50 USD
  None = 'None', // 1,250.50
  Short = 'Short', // $1,250.50
}
